var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExporuseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33301 45.4998V10.2915L15.1663 2.1665L25.9997 10.2915V15.1665H47.6663V45.4998H4.33301ZM8.66634 41.1665H12.9997V36.8332H8.66634V41.1665ZM8.66634 32.4998H12.9997V28.1665H8.66634V32.4998ZM8.66634 23.8332H12.9997V19.4998H8.66634V23.8332ZM8.66634 15.1665H12.9997V10.8332H8.66634V15.1665ZM17.333 15.1665H21.6663V10.8332H17.333V15.1665ZM17.333 41.1665H43.333V19.4998H17.333V41.1665ZM30.333 28.1665V23.8332H38.9997V28.1665H30.333ZM30.333 36.8332V32.4998H38.9997V36.8332H30.333ZM21.6663 28.1665V23.8332H25.9997V28.1665H21.6663ZM21.6663 36.8332V32.4998H25.9997V36.8332H21.6663Z",
    fill: "#699BF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExporuseIcon);
export default __webpack_public_path__ + "static/media/exporuseIcon.f1881795280d8c344bfbcb433825807d.svg";
export { ForwardRef as ReactComponent };